import { StripeLogo } from '@/components/StripeLogo';
import { Button } from '@/components/ui/button';
import { useCreateCustomerPortalSessionMutation } from '@/generated/graphql';
import { toast } from 'sonner';

export function ManageSubscriptionButton() {
  const [createCustomerPortalSession, { loading }] =
    useCreateCustomerPortalSessionMutation();

  const handleClick = async () => {
    try {
      const res = await createCustomerPortalSession();
      const url = res.data?.createCustomerPortalSession.url;

      if (url) {
        window.location.href = url;
      } else {
        console.error('No URL returned from portal session');
        toast.error('Uh oh! Something went wrong.');
      }
    } catch (err) {
      console.error('Error creating customer portal session:', err);
      toast.error('Uh oh! Something went wrong.');
    }
  };

  return (
    <Button disabled={loading} onClick={handleClick}>
      Manage Subscription on <StripeLogo className="ml-1 inline-block h-4" />
    </Button>
  );
}
